import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAuthz from '../../hooks/useAuthz';

const RequesterRenderer = (props) => {
  const reduxBlacklist = useSelector(state => state['Blacklist']);
  const [authz, user, profil] = useAuthz();
  const [blacklisted, setBlacklisted] = useState(false);

  useEffect(() => {
    reduxBlacklist.blacklistedUsers.forEach((blacklisted_user) => {
      if (props.data.metadata.complementIdentite.transporteur === blacklisted_user) {
        setBlacklisted(true);
      }
      else {
        setBlacklisted(false);
      }
    })
  }, [reduxBlacklist.blacklistedUsers])

  if (profil.profil === 1 || profil.profil === 2 || profil.profil === 3 || profil.profil === 4) {
    return (
      <div>
        {
          blacklisted &&
          <FontAwesomeIcon icon={faCircle} style={{ color: '#ff0000', height: '10px', marginRight: '10px' }} />
        }
        {
          !blacklisted &&
          <FontAwesomeIcon icon={faCircle} style={{ color: '#000000', height: '10px', marginRight: '10px' }} />
        }
        <span style={{ textTransform: 'uppercase', fontSize: '12px' }}>{props.data.metadata.complementIdentite.transporteur}</span>
      </div>);
  }

  return (
    <div>
      <span style={{ textTransform: 'uppercase', fontSize: '12px' }}>{props.data.metadata.complementIdentite.transporteur}</span>
    </div>);
};

export default RequesterRenderer;
